import styled, { css } from "styled-components";

type ContainerProps = {
  showTour: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  position: relative;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const ContainerWrap = styled.div`
  position: relative;
`;

export const AccountContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const AvatarContainer = styled.div`
  height: 42px;
  width: 42px;
`;

export const IconContainer = styled.div`
  display: flex;

  & svg {
    font-size: 25px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const InfoContainer = styled.div`
  margin: 0 25px 0 10px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  font-family: "Mangueira bold";
  color: ${({ theme }) => theme.colors.blue};
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const DropdownMenu = styled.div`
  width: 150px;
  z-index: 5;
  background: white;
  position: absolute;
  top: 60px;
  right: 0;
  border-radius: 5px;
  box-shadow: 0 0 8px #d8d8d8;
  display: flex;
  padding: 12px;
  flex-direction: column;
`;

export const Icon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropdownItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;

  & + div {
    margin-top: 8px;
  }

  & svg {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const TextWrap = styled.div`
  height: 24px;
  display: flex;
  align-items: end;
`;

export const DropdownText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray};

  ${DropdownItem}:hover & {
    color: ${({ theme }) => theme.colors.blue};
  }
`;
